import RootLanding from '../../components/layouts/RootLanding';
import useSWR from 'swr';
import { getFetcherPublic } from '../../services/api';
import { useLocation } from 'react-router-dom';
import LayoutRead from '../../components/fragments/landing/LayoutRead';

export default function ReadPage() {
    const location = useLocation();

    const type = location.pathname.split('/')[1];
    const slug = location.pathname.split('/').filter(Boolean).pop();

    const fetchUrl = type === 'berita' ? `/api/content/news/${slug}` : `/api/content/article/${slug}`;
    const { data, error, isLoading } = useSWR(fetchUrl, getFetcherPublic);

    if (isLoading) {
        return <p>Loading....</p>;
    }

    return (
        <RootLanding>
            <LayoutRead
                title={data.title}
                author={data.author}
                content={data.content}
                createdAt={data.createdAt}
                photo={data.photoUrls[0]}
                views={data.views}
                category={data.categories[0].name}
            />
        </RootLanding>
    );
}
